import { Record, Map } from 'immutable'

import { SET_THREAD_DRAFT } from './actionTypes'

const InitialState = Record(
  {
    threadDrafts: new Map(),
  },
  'threads'
)

const threadsReducer = (state = new InitialState(), action) => {
  switch (action.type) {
    case SET_THREAD_DRAFT: {
      const { key, content } = action.payload
      return state.update('threadDrafts', drafts => drafts.set(key, content))
    }
    default: {
      return state
    }
  }
}

export default threadsReducer
